module.exports = __webpack_public_path__ + "static/media/Andromeda.2ccff411.svg";